import React from 'react';
import PropTypes from 'prop-types';

import CustomSwitch from "components/switch/CustomSwitch";

import update from 'api/shippingMethod/update';

ActiveButton.propTypes = {
    shippingMethod: PropTypes.shape({
        active: PropTypes.bool.isRequired
    }).isRequired,
    onClick: PropTypes.func
};

function ActiveButton({shippingMethod, onClick = () => {}}) {
    const [isActive, setIsActive] = React.useState(shippingMethod.active);

    return (
        <CustomSwitch
            name='status'
            checked={isActive}
            onClick={() => {
                setIsActive(!isActive);
                update(shippingMethod, {active: !isActive})
                    .then(() => onClick())
                    .catch(() => setIsActive(isActive));
            }}
        />
    );
}

export default ActiveButton;
